document.addEventListener('DOMContentLoaded', () => listenerElementsApiAdded());

export enum StoplightElementsListener {
  TryItPanelAdded = 'TryItPanelAdded'
}
export type StoplightElementsEvent = CustomEvent<{ node: Element }>;

// Listens for when the Elements API is added to the DOM
const listenerElementsApiAdded = () => {
  const observer = new MutationObserver((mutations) =>
    mutations
      .flatMap((mutation) => [...mutation.addedNodes])
      .flatMap((node): Element[] => (node instanceof Element ? [...node.querySelectorAll('elements-api')] : []))
      .forEach((node) => {
        listenerTryItPanelAdded(node);
        // More listeners can be added here
      })
  );
  observer.observe(document.body, { childList: true, subtree: true });
};

// Listens for when the TryItPanel is added and dispatches an event for 'TryItPanelAdded'
const listenerTryItPanelAdded = (node: Element) => {
  const observer = new MutationObserver((mutations) =>
    mutations
      .flatMap((mutation) => [...mutation.addedNodes])
      .flatMap((node): Element[] => (node instanceof Element ? [...node.querySelectorAll('.TryItPanel')] : []))
      .forEach((node) => dispatchCustomEvent(StoplightElementsListener.TryItPanelAdded, node))
  );
  observer.observe(node, { childList: true, subtree: true });
};

const dispatchCustomEvent = (event: StoplightElementsListener, node: Element) => {
  const detail = { node };
  const customEvent: StoplightElementsEvent = new CustomEvent(event, { detail });
  window.dispatchEvent(customEvent);
};
